import { Lookup } from '@appd/uik';

interface QueryBuilderSelectorProps {
  placeHolder: string;
  value: string;
  options: string[] | undefined;
  onChange: (event: any) => void;
}

export const QueryBuilderSelector = ({ placeHolder, value, options, onChange }: QueryBuilderSelectorProps) => {
  const sortedOptions = options ? options.sort() : [];

  const handleOptionChange = (event: any) => {
    // support single select only
    onChange(sortedOptions[event[0]]);
  };

  return (
    <div className="flex flex-col gap-1 pr-1">
      <Lookup value={[sortedOptions.indexOf(value)]} placeholder={placeHolder} onChange={handleOptionChange}>
        {sortedOptions.map((option, index) => (
          <Lookup.Option key={index}>{option}</Lookup.Option>
        ))}
      </Lookup>
    </div>
  );
};
